import { memo } from "react";
import classNames from "classnames";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { getLeadingAccountConnection } from "@common/helpers/financialAccount";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import { AccountCard } from "@components/financialAccount/AccountCard/AccountCard";
import { HStack } from "@design-system/HStack/HStack";
import { AccountsTableRow } from "../accountsView.types";
import styles from "../accountsView.module.scss";

export const EntityOrAccountCell = memo(
    ({ row }: CellContext<ViewTableFeatures, AccountsTableRow, unknown>) => {
        const rowData = row.original;
        if (!rowData.account) {
            return (
                <ViewTableCell>
                    <HStack gap={8} align="center">
                        <EntityAvatar
                            entity={rowData.entity}
                            size="xs"
                            aria-hidden
                        />
                        <span className={styles.entityName}>
                            {rowData.entity.name}
                        </span>
                    </HStack>
                </ViewTableCell>
            );
        }

        const connection = getLeadingAccountConnection(rowData.account);
        return (
            <ViewTableCell
                className={classNames({
                    [styles.accountCellDisabled]: rowData.account.disabled,
                })}
            >
                <AccountCard
                    account={rowData.account}
                    connection={connection ?? undefined}
                    numberInName
                    showType={false}
                    iconSize="sm"
                />
            </ViewTableCell>
        );
    },
);

EntityOrAccountCell.displayName = "EntityOrAccountCell";
